<template>
  <RevButtonBase
    :aria-expanded="isOpen"
    :aria-label="i18n(translations.title)"
    class="text-static-default-hi rounded-md flex items-center justify-center gap-8 p-4 hover:text-action-default-hi-hover"
    data-test="country-switch-menu-button"
    @click="
      () => {
        trackButtonClick()
        $emit('click')
      }
    "
  >
    <RevCountryFlag v-if="countryCode" class="rounded-xs" :country-code />
    <div class="caption-bold">
      {{ countryCode }}
    </div>
  </RevButtonBase>
</template>

<script setup lang="ts">
import type { CountryCodeValue } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCountryFlag } from '@ds/components/CountryFlag'

import translations from './CountrySwitch.translations'

const { countryCode, trackingSpot } = defineProps<{
  countryCode: CountryCodeValue
  isOpen: boolean
  trackingSpot: 'header' | 'nav'
}>()
const i18n = useI18n()

const { trackCountrySwitchClick } = useTracking()

const trackButtonClick = () => {
  trackCountrySwitchClick({
    name: 'country_switch',
    zone: trackingSpot,
  })
}

defineEmits(['click'])
</script>
